import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Palette, ChevronDown, Calculator } from 'lucide-react';

const Hero = () => {
  const { t, language } = useLanguage();

  // O cartão da simulação por WhatsApp saiu daqui a 07/09/2026, com o sim da Rute
  // no grupo. A simulação continua no site, dentro do CustomMix (Mistura
  // Personalizada); o que mudou foi o lugar mais caro da página, que passa a ser
  // a calculadora -- a única peça que devolve a área e o que a pessoa vai pintar
  // sem custar um minuto à loja. Até aqui não havia ligação nenhuma para ela na
  // página principal.
  const calcTitle = language === 'pt' ? 'Calculadora de tinta' : 'Paint calculator';
  const calcText = language === 'pt'
    ? 'Diga as medidas e veja quantos litros precisa, com os números da ficha técnica.'
    : 'Enter your measurements and see how many litres you need, using the manufacturer\u2019s figures.';
  const calcCta = language === 'pt' ? 'Abrir a calculadora' : 'Open the calculator';
  const mixCta = language === 'pt' ? 'Pedir a minha cor' : 'Ask for my colour';

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('/assets/hero-bg.webp')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/85 via-gray-800/75 to-gray-900/90" />
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-orange-500/10 to-transparent" />
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-emerald-500/10 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="text-center">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 leading-tight">
            {t('hero.title')}
          </h1>

          {/* Secondary text */}
          <p className="text-base md:text-lg text-orange-300 font-medium mb-16">
            {t('hero.secondary')}
          </p>

          {/* Highlights Grid - 2 items */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {/* Mistura Personalizada — era uma <div> sem ligação nenhuma até 07/09/2026 */}
            <a
              href="/#custom-mix"
              className="group flex flex-col bg-gray-900/70 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-gray-900/85 hover:border-white/35 transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              <div className="flex justify-center mb-4">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br from-orange-500 to-red-500 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Palette className="w-7 h-7 text-white" />
                </div>
              </div>

              <h3 className="text-xl font-semibold text-white mb-2">
                {t('highlights.mix.title')}
              </h3>
              <p className="text-white/80 text-sm leading-relaxed mb-6">
                {t('highlights.mix.description')}
              </p>

              <span className="mt-auto inline-flex items-center justify-center gap-2 rounded-xl border border-white/30 bg-white/10 px-5 py-3 text-sm font-semibold text-white group-hover:bg-white/20 group-hover:border-white/50 transition-colors">
                {mixCta} &rarr;
              </span>
            </a>

            {/* Calculadora de tinta (substituiu o cartão da simulação, 07/09/2026).
                É o cartão prioritário: botão cheio e contorno cor de laranja, para haver
                hierarquia entre os dois em vez de dois iguais a competir. */}
            <a
              href="/calculadora/"
              className="group flex flex-col bg-gray-900/70 backdrop-blur-md border border-orange-500/50 rounded-2xl p-6 shadow-lg shadow-orange-900/20 hover:bg-gray-900/85 hover:border-orange-500/80 transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              <div className="flex justify-center mb-4">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br from-orange-500 to-red-500 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Calculator className="w-7 h-7 text-white" />
                </div>
              </div>

              <h3 className="text-xl font-semibold text-white mb-2">
                {calcTitle}
              </h3>
              <p className="text-white/80 text-sm leading-relaxed mb-6">
                {calcText}
              </p>

              {/* Sem imagem de propósito: o cartaz da calculadora é 1200×900 e, cortado
                  para a altura deste cartão, aparece uma tira escura que não se lê. */}
              <span className="mt-auto inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-red-500 px-5 py-3 text-sm font-semibold text-white shadow-lg group-hover:opacity-90 transition-opacity">
                {calcCta} &rarr;
              </span>
            </a>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-white/50" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
